import { Navigate } from 'react-router-dom';
import { getAuthToken, getUserRole, getLastPortal } from '@/lib/auth';

export const ProtectedRoute = ({ children, allowedRoles }) => {
  const token = getAuthToken();
  const userRole = getUserRole();
  const isOpsRoute = window.location.pathname.startsWith('/ops');
  // Use stored portal preference — reliable even after refresh (window.location may not start with /ops)
  const loginPath = getLastPortal() === 'ops' ? '/ops/login' : '/login';

  if (!token) {
    return <Navigate to={loginPath} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(userRole) && userRole !== 'super_admin') {
    // Redirect to appropriate dashboard based on role
    const roleRoutes = {
      customer: '/customer',
      agent: '/ops/agent',
      foc: '/ops/foc',
      technician: '/ops/tech',
      super_admin: '/ops/admin',
    };
    return <Navigate to={roleRoutes[userRole] || (isOpsRoute ? '/ops/login' : '/login')} replace />;
  }

  return children;
};